function About() {
  return (
    <div>
      <h1>ABOUT OUTLND</h1>
    </div>
  )
}

export default About;